// extracted by mini-css-extract-plugin
module.exports = {"serverErrorMessage":"ContactResponse_server-error-message__31-HA"};